import { z } from 'zod';
const finite = z.number().finite();
export const Vec3Schema = z.object({ x: finite, y: finite, z: finite }).strict();
/** Validated at the network boundary in Phase 4; the client also uses it for local sanity. */
export const MechInputSchema = z
    .object({
    seq: z.number().int().nonnegative(),
    moveX: finite.min(-1).max(1),
    moveY: finite.min(-1).max(1),
    aimYaw: finite,
    aimPitch: finite.min(-Math.PI / 2).max(Math.PI / 2),
    boost: z.boolean(),
    jump: z.boolean(),
    primary: z.boolean(),
    secondary: z.boolean(),
    ability: z.boolean(),
    ultimate: z.boolean(),
    vent: z.boolean(),
    melee: z.boolean(),
})
    .strict();
export const MechStateSchema = z
    .object({
    tick: z.number().int().nonnegative(),
    position: Vec3Schema,
    velocity: Vec3Schema,
    yaw: finite,
    aimYaw: finite,
    aimPitch: finite,
    energy: finite.nonnegative(),
    grounded: z.boolean(),
    airTicks: z.number().int().nonnegative(),
    regenDelayTicks: z.number().int().nonnegative(),
    boosting: z.boolean(),
    jetting: z.boolean(),
    jumpHeld: z.boolean(),
    alive: z.boolean(),
})
    .strict();
//# sourceMappingURL=schemas.js.map